import { determineCategoryApiUrl } from './urls';
import { CategoryPageLinkApiRequestParams } from 'models/CategoryPageLinkApiRequestParams';
import { CategoryPageLinkApiResponse } from 'models/CategoryPageLinkApiResponse';
import { STATUS_CODES } from 'helpers/statusCodes';

export const getCategoryPageLinksFromApi = async ({
  environment,
  category
}: CategoryPageLinkApiRequestParams): Promise<CategoryPageLinkApiResponse> => {
  const url = new URL(determineCategoryApiUrl(environment));
  url.searchParams.append('category', category);

  const response: Response = await fetch(url.toString());

  if (!response.ok && response.status === STATUS_CODES.NOT_FOUND) {
    throw STATUS_CODES.GONE;
  }

  try {
    return (await response.json()) as CategoryPageLinkApiResponse;
  } catch (error) /* istanbul ignore next */ {
    // TODO: Remove this as soon as SEO-1338 works again!
    if (response.ok && response.status === STATUS_CODES.OK) {
      throw STATUS_CODES.GONE;
    }
    throw error;
  }
};
